import CancelModal from "./CancelModal";
import SiteDataModal from "./SiteDataModal";
import RemoveCircuitModal from "./RemoveCircuitModal";
import NotesModal from "./NotesModal";
import AddTempSiteModal from "./AddTempSiteModal";
import AddTempStructureModal from "./AddTempStructureModal";
import StructureDataModal from "./StructureDataModal";
import DiverseModal from "./DiverseModal";

const ModalRenderer = ({ modal, closeModal }) => {
  if (!modal.type) return null;

  switch (modal.type) {
    case "CANCEL_SITE":
      return <CancelModal {...modal.props} show setShow={closeModal} />;

    case "SITE_DATA":
      return <SiteDataModal {...modal.props} show setShow={closeModal} />;

    case "STRUCTURE_DATA":
      return <StructureDataModal {...modal.props} show setShow={closeModal} />;

    case "REMOVE_CIRCUIT":
      return <RemoveCircuitModal {...modal.props} setCircuit={closeModal} />;
    case "DIVERSE_GROUP":
      return (
        <DiverseModal
          show
          setShow={closeModal}
          diversityGroups={modal.props.diversityGroups}
          circuits={modal.props.circuits}
          siteId={modal.props.siteId}
          siteName={modal.props.siteName}
          handleGroupMoveUpdate={modal.props.handleGroupMoveUpdate}
        />
      );

    case "NOTES":
      return <NotesModal {...modal.props} setNotesModal={closeModal} />;

    case "ADD_TEMP_SITE":
      return <AddTempSiteModal {...modal.props} setModalData={closeModal} />;

    case "ADD_TEMP_STRUCTURE":
      return (
        <AddTempStructureModal {...modal.props} setModalData={closeModal} />
      );

    default:
      return null;
  }
};

export default ModalRenderer;
